<template>
  <transition
    :appear="appear"
    enter-active-class="transition-opacity duration-300"
    enter-from-class="opacity-0"
    leave-active-class="transition"
    leave-to-class="opacity-0"
    :mode="mode"
  >
    <slot />
  </transition>
</template>

<script lang="ts" setup>
import type { TransitionProps } from "vue";

defineProps<{
  appear?: boolean;
  mode?: TransitionProps["mode"];
}>();
</script>
